import { useEffect } from 'react';
import { useQuery } from '@apollo/react-hooks';
import { useDispatch } from 'react-redux';
import { GET_VERSION_DATA } from "../graphql/queries";

export default () => {
    const dispatch = useDispatch();
    const { data } = useQuery(GET_VERSION_DATA, { fetchPolicy: 'cache-and-network' });

    useEffect(() => {
        dispatch({ type: 'SET_VERSION', version: data });
    }, [data]);

    return ('');
};
